<template>
  <div class="min-h-screen font-sans transition-colors duration-300">
    <div
      class="bg-background-light dark:bg-background-dark text-slate-800 dark:text-slate-100"
    >
      <main class="container mx-auto px-4 py-12">
        <div class="text-center mb-16">
          <h2
            class="text-3xl font-bold text-center mb-10 text-gray-700 title-underline uppercase"
          >
            Sales Contact
          </h2>
        </div>

        <div class="flex flex-col lg:flex-row gap-12 px-6 mx-auto">
          <div class="flex-1">
            <email-sender></email-sender>
          </div>

          <div class="lg:w-96">
            <div
              class="bg-gray-50 p-8 rounded-2xl shadow-xl border border-gray-100"
            >
              <h3 class="text-sm text-left mb-6 leading-tight">
                <span class="font-bold">Dongguan Huadai Silicone Co.Ltd. </span
                ><br />
                Room 101, Building 1, No.128 Huaxia Road, Qiaotou Town, Dongguan
                City, Guangdong Province, China
              </h3>

              <div class="space-y-5 text-sm text-gray-600">
                <div class="flex items-center space-x-4">
                  <i class="fa fa-phone mr-2 text-primary"></i>
                  <p>+86 139 2377 6251</p>
                </div>
                <div class="flex items-center space-x-4">
                  <i class="fa fa-envelope mr-2 text-primary"></i>
                  <p>sales@hdsilicone.com</p>
                </div>
                <div class="flex items-center space-x-4">
                  <i class="fa fa-comment mr-2 text-primary"></i>
                  <p>WhatsApp: +86 139 2377 6251</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import EmailSender from '@/components/emailform/Email'
export default {
  name: 'Contact',
  components: {
    EmailSender
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title-underline {
  position: relative;
  display: inline-block;
}
.title-underline::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 100%;
  height: 8px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 20" preserveAspectRatio="none"><path d="M0 15 Q 25 5, 50 15 T 100 15" stroke="%23004494" stroke-width="4" fill="transparent"/></svg>');
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/contact/Contact.vue